<template>
  <section class="hub-contact" id="kontakt">
    <div class="container">
      <div class="contact-shell">
        <div>
          <span class="subtitle">Kontakt</span>
          <h2>Sie sind noch nicht sicher, welcher Bereich passt?</h2>
          <p>
            Kein Problem. Schreiben Sie einfach kurz, worum es geht. Dann lässt sich schnell klären, welcher Bereich für Ihr Thema der richtige ist.
          </p>
        </div>

        <div class="contact-actions">
          <router-link to="/kontakt" class="btn-primary">Kontakt aufnehmen</router-link>
          <router-link to="/#portfolio" class="btn-secondary">Bereiche ansehen</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HubContactCta'
};
</script>

<style lang="scss" scoped>
@use "@/assets/css/global.scss" as *;

.hub-contact {
  background: linear-gradient(135deg, #eaf0f5, rgba($accent-teal, 0.04));
  color: $text-color;
}

.contact-shell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.contact-shell p {
  max-width: 720px;
  color: $text-color;
}

.contact-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

@media (max-width: 991px) {
  .contact-shell {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
